import { Navigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common/Common";
import { useAuth } from "@/context/AuthContext";
import { UsersTab } from "./UsersTab";
import { SettingsTab } from "./SettingsTab";
import { BlockedTab } from "./BlockedTab";
import { ChecklistItemsTab } from "./ChecklistItemsTab";
import { LookupTable } from "./LookupTable";
import { AuditTab, EmailLogTab } from "./LogTabs";

export default function AdminPage() {
  const { isAdmin, canWrite } = useAuth();
  if (!canWrite) return <Navigate to="/dashboard" replace />;
  return (
    <div>
      <PageHeader title="Admin" subtitle={isAdmin ? "Users, settings, email safety and lookup lists." : "Lookup lists (admins manage users and settings)."} testId="admin-header" />
      <Tabs defaultValue={isAdmin ? "users" : "lookups"}>
        <TabsList className="bg-white border border-slate-200 flex-wrap h-auto" data-testid="admin-tabs">
          {isAdmin && <TabsTrigger value="users" data-testid="admin-tab-users">Users & roles</TabsTrigger>}
          {isAdmin && <TabsTrigger value="settings" data-testid="admin-tab-settings">Settings</TabsTrigger>}
          {isAdmin && <TabsTrigger value="blocked" data-testid="admin-tab-blocked">Blocked recipients</TabsTrigger>}
          {isAdmin && <TabsTrigger value="checklist" data-testid="admin-tab-checklist">Checklist items</TabsTrigger>}
          <TabsTrigger value="lookups" data-testid="admin-tab-lookups">Lookup lists</TabsTrigger>
          <TabsTrigger value="audit" data-testid="admin-tab-audit">Audit log</TabsTrigger>
          {isAdmin && <TabsTrigger value="email" data-testid="admin-tab-email">Email log</TabsTrigger>}
        </TabsList>
        <div className="mt-5">
          {isAdmin && <TabsContent value="users"><UsersTab /></TabsContent>}
          {isAdmin && <TabsContent value="settings"><SettingsTab /></TabsContent>}
          {isAdmin && <TabsContent value="blocked"><BlockedTab /></TabsContent>}
          {isAdmin && <TabsContent value="checklist"><ChecklistItemsTab /></TabsContent>}
          <TabsContent value="lookups" className="space-y-6">
            <LookupTable title="Super funds" path="/super-funds" testId="super-funds" fields={[{ key: "name", label: "Name" }, { key: "short_name", label: "Short name" }, { key: "spin_usi", label: "SPIN / USI" }]} />
            <LookupTable title="Job positions" path="/job-positions" testId="job-positions" fields={[{ key: "name", label: "Name" }]} />
            <LookupTable title="Job locations" path="/job-locations" testId="job-locations" fields={[{ key: "name", label: "Name" }]} />
          </TabsContent>
          <TabsContent value="audit"><AuditTab /></TabsContent>
          {isAdmin && <TabsContent value="email"><EmailLogTab /></TabsContent>}
        </div>
      </Tabs>
    </div>
  );
}
